import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "primary",
  style: {"padding":"10px 0","min-width":"180px","max-width":"280px"}
}
const _hoisted_2 = { class: "ml_5" }


import SvgIcon from '@/components/icons/SvgIcon.vue'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: ['tooltip'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (__props.tooltip)
    ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        placement: "top",
        effect: "light",
        "hide-after": 30,
        offset: 5
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(SvgIcon, {
              name: "提示",
              style: {"font-size":"14px"}
            }),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)(__props.tooltip)), 1)
          ])
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})